module.exports = "<div class=\"space-display-msg\">\r\n  <div *ngFor=\"let alert of getAlertsList(); let i = index\"\r\n       class=\"alert\"\r\n       [ngClass]=\"'alert-' + alert.type\"\r\n       role=\"alert\">\r\n    <button type=\"button\" class=\"close\" (click)=\"closeAlert(i)\">\r\n      <span aria-hidden=\"true\">x</span>\r\n      <span class=\"sr-only\">Close</span>\r\n    </button>\r\n    <div><pre>{{alert.message}}</pre></div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/alert/components/templates/alert.component.html
// module id = ./src/app/shared/alert/components/templates/alert.component.html
// module chunks = main